import { Box, Divider, Typography } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import React from 'react'
import EDDrawerBody from './EDDrawerBody'

const EDDrawer = ({ title, drawerState, handleDrawer, staff }) => {
  return (
    <Box>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        sx={{ padding: 0 }}
        sxIcon={{ display: 'flex', alignItems: 'center', mr: 5 }}
        sxHeader={{ height: 50 }}
        headerprops={
          <Typography variant='body1' display="flex" alignItems="center" ml={5}>
            {title}
          </Typography>
        }
      >
        <Divider />
        <EDDrawerBody title={title} staff={staff} />
      </AdxDrawerComponent>
    </Box>
  )
}

export default EDDrawer
